// v18 IndexedDB → v19 数据迁移 (R12 数据保护)
// 用户首次打开 v19.trungnam.net 时自动检测 + 迁移

import { openDB } from 'idb'

const V18_IDB_NAME = 'trungnam_mes'  // v18 IDB 库名
const V19_IDB_NAME = 'trungnam-mes-v19'

interface MigrationResult {
  status: 'success' | 'skip' | 'error'
  v18Found: boolean
  recordsMigrated: number
  message: string
}

export async function migrateFromV18(): Promise<MigrationResult> {
  try {
    // Step 1 · 检测 v18 IDB 是否存在
    const databases = await indexedDB.databases?.() || []
    const v18Exists = databases.some(db => db.name === V18_IDB_NAME)

    if (!v18Exists) {
      return { status: 'skip', v18Found: false, recordsMigrated: 0, message: '没有 v18 数据需要迁移' }
    }

    // Step 2 · 打开 v18 IDB (只读)
    const v18Db = await openDB(V18_IDB_NAME, undefined)
    const sqliteData = await v18Db.get('sqlite', 'main')

    if (!sqliteData) {
      v18Db.close()
      return { status: 'skip', v18Found: true, recordsMigrated: 0, message: 'v18 IDB 无 sqlite 数据' }
    }

    // Step 3 · 写入 v19 IDB
    const v19Db = await openDB(V19_IDB_NAME, 1, {
      upgrade(database) {
        if (!database.objectStoreNames.contains('sqlite')) {
          database.createObjectStore('sqlite')
        }
      }
    })
    await v19Db.put('sqlite', sqliteData, 'main')
    v19Db.close()
    v18Db.close()

    // Step 4 · 标记已迁移 (避免重复)
    try { localStorage.setItem('tn_v19_migrated_at', new Date().toISOString()) } catch(_e) {}

    return {
      status: 'success',
      v18Found: true,
      recordsMigrated: 1,
      message: 'v18 IDB 迁移到 v19 成功'
    }
  } catch (err) {
    console.warn('[migrate] v18 → v19 failed', err)
    return {
      status: 'error',
      v18Found: false,
      recordsMigrated: 0,
      message: 'v18 数据迁移失败: ' + (err instanceof Error ? err.message : String(err))
    }
  }
}

// v19 启动时自动调用 (仅 1 次)
export async function autoMigrateOnStartup(): Promise<void> {
  const migratedAt = localStorage.getItem('tn_v19_migrated_at')
  if (migratedAt) {
    console.info('[migrate] 已迁移于', migratedAt, '· skip')
    return
  }
  const result = await migrateFromV18()
  console.info('[migrate] result:', result)
}
